(function () {
  'use strict';

  var section = document.querySelector('.form--container.tripleseat[data-form-id]');
  if (!section) return;

  // Optional — pages that don't need the custom 5+1 location dropdown skip it
  // (snippet rendered with include_location_dropdown: false). All other decoration
  // — asterisks, error messages, Ext hide, time row, scroll fix, lead_submit —
  // still runs in either case.
  var template = section.querySelector('template.oa-location-template');

  function ensureTS(cb) {
    if (typeof window.TS !== 'undefined' &&
        typeof window.TS.custom_pre_submit_hook === 'function' &&
        typeof window.jQuery !== 'undefined') {
      cb();
    } else {
      setTimeout(function () { ensureTS(cb); }, 50);
    }
  }

  function showSuccess() {
    var success = document.createElement('div');
    success.className = 'tripleseat-success-message';
    success.innerHTML = '<p>Thanks for thinking of Threes Brewing for your event - our events team will be in touch shortly.</p>';
    section.innerHTML = '';
    section.appendChild(success);

    // Replacing the tall form with a short message collapses the page height,
    // which can leave the viewport scrolled down to the footer. Bring the
    // confirmation back into view so it isn't missed.
    if (success.scrollIntoView) {
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Last path segment (e.g. "/pages/weddings-receptions" -> "weddings-receptions").
    var leadPage = location.pathname.replace(/\/+$/, '').split('/').pop() || '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'lead_submit',
      lead_page: leadPage
    });
  }

  function patchSubmit() {
    if (!window.TS ||
        !window.TS.DynamicLeadFormsShared ||
        typeof window.TS.DynamicLeadFormsShared.submitDynamicLeadForm !== 'function') {
      setTimeout(patchSubmit, 50);
      return;
    }
    if (window.TS.DynamicLeadFormsShared.__oaPatched) return;
    window.TS.DynamicLeadFormsShared.__oaPatched = true;

    window.TS.DynamicLeadFormsShared.submitDynamicLeadForm = function (form) {
      try {
        if (form.getAttribute('data-submitting') === '1') return;

        if (typeof window.TS.validate_form_submission === 'function' &&
            !window.TS.validate_form_submission()) {
          return;
        }

        form.setAttribute('data-submitting', '1');

        var submitBtn = form.querySelector('button[type="submit"], input[type="submit"], .tripleseat-dlf-submit');
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

        var formData = new FormData(form);

        // Write the guest's true location choice into the dedicated TripleSeat
        // custom field (for every pick, not just fallbacks) so it always shows
        // as its own field on the lead.
        var locSelect = section.querySelector('select[name="oa_location"]');
        var selected = locSelect && locSelect.options[locSelect.selectedIndex];
        if (selected && selected.dataset.trueLocation) {
          formData.set('form_data[Requested Location]', selected.dataset.trueLocation);
        }

        var action = form.getAttribute('action');
        var headers = {};
        var csrf = document.querySelector('meta[name="csrf-token"]');
        if (csrf && csrf.content) headers['X-CSRF-Token'] = csrf.content;

        window.fetch(action, {
          method: 'POST',
          body: formData,
          headers: headers,
          credentials: 'omit',
          redirect: 'follow'
        }).then(function (resp) {
          if (resp.ok) {
            showSuccess();
            return;
          }
          throw new Error('Form submission failed with status ' + resp.status);
        }).catch(function (err) {
          if (window.console && console.error) console.error('Form submit error:', err);
          window.alert('We\'re experiencing technical difficulties. Please try again in a few moments.');
          if (submitBtn) submitBtn.disabled = false;
          form.removeAttribute('data-submitting');
        });
      } catch (e) {
        if (window.console && console.error) console.error('Submit exception:', e);
        form.removeAttribute('data-submitting');
      }
    };
  }
  patchSubmit();

  ensureTS(function () {
    window.TS.custom_scroll_to_errors = function () {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    window.TS.custom_pre_submit_hook = function () {};

    window.TS.custom_errors_callback = function (errors) {
      Object.keys(errors || {}).forEach(function (key) {
        var ids = [
          key,
          key.replace(/\s+/g, '_'),
          key.replace(/^form_data\[/, '').replace(/\]$/, '')
        ];
        ids.forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.classList.add('error');
        });
      });

      if (errors && (errors['Location'] || errors['location_id'] || errors['form_data[location_id]'])) {
        var locEl = section.querySelector('select[name="oa_location"]');
        if (locEl) locEl.classList.add('error');
      }
    };

    window.TS.custom_success_callback = showSuccess;
  });

  // TripleSeat only renders an inline "can't be blank" message when a
  // <div id="{field-name}_error"> already exists, and its lookup key is the
  // field's full `name` attribute. The only shipped div that matches that key
  // is location's, so location is the only field that shows a message. We give
  // every required field (a) a red asterisk on its label and (b) a matching
  // error div, so TS's own validation reveals a message for all of them.
  function enhanceRequiredFields(form) {
    form.querySelectorAll('[required], [data-required="true"], .tripleseat-dlf-number').forEach(function (field) {
      var name = field.getAttribute('name');
      if (!name) return;

      // Number fields (e.g. guest count) aren't flagged `required`, but TS
      // blocks submission when they enforce a positive minimum — treat those as
      // required too, and skip number fields that don't enforce one.
      var minValue = parseInt(field.getAttribute('data-min-value'), 10);
      var isNumber = field.classList.contains('tripleseat-dlf-number');
      var isRequired = field.hasAttribute('required') || field.getAttribute('data-required') === 'true';
      if (isNumber && !isRequired && !(minValue > 0)) return;

      // The field's nearest wrapper. Name fields use .tripleseat-dlf-name-field
      // and SHARE one outer .tripleseat-dlf-field-group, so we must resolve each
      // field's own label rather than the first label in a shared group.
      var wrap = field.closest('.tripleseat-dlf-name-field') ||
                 field.closest('.tripleseat-dlf-field-group') ||
                 field.parentNode;

      // Prefer the label explicitly tied to this field via for="id".
      var labelEl = null;
      var fid = field.getAttribute('id');
      if (fid) {
        var sel = (window.CSS && CSS.escape) ? CSS.escape(fid) : fid;
        labelEl = form.querySelector('label[for="' + sel + '"]');
      }
      if (!labelEl) labelEl = wrap.querySelector('.tripleseat-dlf-label');

      // For the location field the for="" label is the hidden native one we
      // replaced; put the asterisk on the visible dropdown label instead.
      if (labelEl && labelEl.classList.contains('oa-visually-hidden')) {
        labelEl = wrap.querySelector('.tripleseat-dlf-label:not(.oa-visually-hidden)') || labelEl;
      }

      if (labelEl && !labelEl.querySelector('.oa-required')) {
        var star = document.createElement('span');
        star.className = 'oa-required';
        star.setAttribute('aria-hidden', 'true');
        star.textContent = ' *';
        labelEl.appendChild(star);
      }

      var errorId = name + '_error';
      if (!document.getElementById(errorId)) {
        var message;
        if (isNumber && field.getAttribute('data-min-message')) {
          message = field.getAttribute('data-min-message');
        } else {
          var labelText = labelEl ? labelEl.textContent.replace('*', '').trim() : 'This field';
          message = labelText + ' can’t be blank';
        }
        var err = document.createElement('div');
        err.id = errorId;
        err.className = 'tripleseat-dlf-error';
        err.style.display = 'none';
        err.setAttribute('role', 'alert');
        err.textContent = message;
        wrap.appendChild(err);
      }
    });
  }

  function decorate() {
    var form = section.querySelector('#dynamic_lead_form');
    if (!form) return false;
    if (form.classList.contains('oa-decorated')) return true;
    form.classList.add('oa-decorated');

    // Location decoration is opt-in: only runs when the snippet rendered the
    // <template> (include_location_dropdown !== false) AND the form actually
    // has a native location_id select to replace.
    var select = form.querySelector('select[name="form_data[location_id]"]');
    if (template && select) {
      var fieldGroup = select.closest('.tripleseat-dlf-field-group') || select.parentNode;
      var label = fieldGroup.querySelector('label[for="form_data_location_id"]');

      var fragment = template.content.cloneNode(true);
      fieldGroup.insertBefore(fragment, fieldGroup.firstChild);

      if (label) label.classList.add('oa-visually-hidden');
      select.classList.add('oa-visually-hidden');

      // Replace TS's pre-rendered "Please Select One" with the same
      // "{Label} can't be blank" wording every other required field uses.
      var locationErrorDiv = document.getElementById('form_data[location_id]_error');
      if (locationErrorDiv) locationErrorDiv.textContent = 'Location can’t be blank';

      // TripleSeat custom field that captures the true location the guest picked
      // (so the events team sees it even when we route to a fallback venue). We
      // hide it from the guest and populate it ourselves.
      var requestedLocation = form.querySelector('#Requested_Location');
      if (requestedLocation) {
        var rlGroup = requestedLocation.closest('.tripleseat-dlf-field-group');
        if (rlGroup) rlGroup.classList.add('oa-hidden-field');
      }

      var locationSelect = section.querySelector('select[name="oa_location"]');
      if (locationSelect) {
        locationSelect.addEventListener('change', function () {
          var opt = locationSelect.options[locationSelect.selectedIndex];
          if (!opt) return;
          select.value = opt.dataset.tsLocationId || '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (requestedLocation) requestedLocation.value = opt.dataset.trueLocation || '';
          locationSelect.classList.remove('error');
        });
      }
    }

    var dateHelp = form.querySelector('#event_date_help');
    if (dateHelp) {
      dateHelp.textContent = 'Enter date in YYYY/MM/DD format or click calendar icon';
    }

    form.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      if (el.type !== 'date') {
        el.removeAttribute('placeholder');
      }
    });

    // Client doesn't want the phone extension field. TripleSeat bakes it into
    // the phone container, so we hide it and let the phone input fill the row.
    var extInput = form.querySelector('#_extension');
    var extLabel = form.querySelector('label[for="_extension"]');
    if (extInput) extInput.classList.add('oa-hidden-field');
    if (extLabel) extLabel.classList.add('oa-hidden-field');

    var startInput = form.querySelector('#start_time');
    var endInput = form.querySelector('#end_time');
    var startGroup = startInput && startInput.closest('.tripleseat-dlf-field-group');
    var endGroup = endInput && endInput.closest('.tripleseat-dlf-field-group');
    if (startGroup && endGroup && startGroup.parentNode === endGroup.parentNode &&
        !startGroup.parentNode.classList.contains('oa-time-row')) {
      var wrap = document.createElement('div');
      wrap.className = 'oa-time-row';
      startGroup.parentNode.insertBefore(wrap, startGroup);
      wrap.appendChild(startGroup);
      wrap.appendChild(endGroup);
    }

    enhanceRequiredFields(form);

    return true;
  }

  if (!decorate()) {
    var decorated = false;
    var observer = new MutationObserver(function (_m, obs) {
      if (decorate()) {
        decorated = true;
        obs.disconnect();
      }
    });
    observer.observe(section, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
      if (!decorated) {
        var fallback = section.querySelector('#tripleseat_link');
        if (fallback) fallback.style.display = 'block';
      }
    }, 15000);
  }
})();
